import * as React from "react";
import { ImageFieldProps, useRecordContext } from "react-admin";

const modalStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

interface CastingConditionalImageFieldProps extends ImageFieldProps {
  source: string;
}

const CastingConditionalImageField = (
  props: CastingConditionalImageFieldProps,
) => {
  const record = useRecordContext(props);
  const [open, setOpen] = React.useState(false);
  if (record && Array.isArray(record[props.source])) {
    for (const aPic of record[props.source]) {
      if (aPic?.url === "default") {
        aPic.url = "/images/default.webp";
      }
    }
  } else if (record && record[props.source] === "default") {
    record[props.source] = "/images/default.webp";
  }
  return record ? (
    <>
      <span
        style={{ cursor: "pointer", padding: 8 }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <img src={record?.vignette_url} alt="casting" height={"250"} />
      </span>
      {open && record.picture_url && (
        <div style={modalStyle} onClick={() => setOpen(false)}>
          <img
            src={record.picture_url}
            alt="popup"
            style={{ boxShadow: "0 0 20px #000" }}
            // onClick={(e) => e.stopPropagation()}
            height="80%"
          />
        </div>
      )}
    </>
  ) : null;
};

export default CastingConditionalImageField;
